import { ReactNode, useEffect, useRef } from "react";
import styles from "./style.module.scss";

export default function ScrollVertical({ children }: { children: ReactNode }) {
    const rootRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const el = rootRef.current;
        if (!el) return;

        const onWheel = (e: WheelEvent) => {
            e.preventDefault();

            const item = el.children[0] as HTMLElement;
            if (!item) return;

            const step = item.offsetWidth + 16; // width + gap

            if (e.deltaY > 0) {
                el.scrollBy({ left: step, behavior: "smooth" });
            } else {
                el.scrollBy({ left: -step, behavior: "smooth" });
            }
        };

        el.addEventListener("wheel", onWheel, { passive: false });
        return () => el.removeEventListener("wheel", onWheel);
    }, []);


    return <div ref={rootRef} className={styles.scrolls} >
        {children}
    </div>;
}
